export enum MeterType {
  G4_G6 = 'G4_G6',

  G10 = 'G10',

  G16 = 'G16',

  G25 = 'G25',

  NULL = 'NULL',
}
